import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { combineLatest, Observable } from 'rxjs';
import { DockOverviewState } from './dock-overview.state';
import { DockOverviewClone, DockOverviewInitialState, DockOverviewLoad } from './dock-overview.actions';
import { DockOverview } from '../../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common/models';
import { HubItemFacade } from '../../../hub/item';
import { take } from 'rxjs/operators';
import { CompartmentItemFacade } from '../../../compartment/item';

@Injectable({ providedIn: 'root' })
export class DockOverviewFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(DockOverviewState.getLoaded);
  name$: Observable<string> = this.store.select(DockOverviewState.getName);
  overview$: Observable<DockOverview> = this.store.select(DockOverviewState.getOverview);

  constructor(
    private store: Store,
    private hubItemFacade: HubItemFacade,
    private compartmentItemFacade: CompartmentItemFacade,
  ) {}

  loadAll(dockId: number): void {
    this.getDockRelatedIds().subscribe(([hubId, compartmentId]: [number, number]) =>
      this.store.dispatch(new DockOverviewLoad({ dockId, hubId, compartmentId })),
    );
  }

  loadByParams(dockId: number, compartmentId: number, hubId: number): void {
    this.store.dispatch(new DockOverviewLoad({ dockId, compartmentId, hubId }));
  }

  cloneDock(dockId: number): void {
    this.getDockRelatedIds().subscribe(([hubId, compartmentId]: [number, number]) =>
      this.store.dispatch(new DockOverviewClone({ dockId, hubId, compartmentId })),
    );
  }

  setInitialState(): void {
    this.store.dispatch(new DockOverviewInitialState());
  }

  private getDockRelatedIds(): Observable<[number, number]> {
    return combineLatest([this.hubItemFacade.hubId$, this.compartmentItemFacade.compartmentId$]).pipe(take(1));
  }
}
